import React from 'react';
import { Navigate } from 'react-router-dom';
import { Spinner } from 'react-bootstrap';
import { useAuthenticator } from '@aws-amplify/ui-react';
import { useOrganization } from '../../contexts/OrganizationContext';

/**
 * Sends an authenticated user who belongs to NO organization to /account-setup before they can reach
 * any app page. Runs outside TrialGuard/AuthWrapper, so a no-org user never renders the app chrome
 * (and never sees a stale org behind a modal). Users who have an organization pass straight through.
 */
const AccountSetupGate = ({ children }) => {
  const { hasOrganizations, isLoading, orgsFetched } = useOrganization();
  const { authStatus } = useAuthenticator((context) => [context.authStatus]);

  // Don't act on incomplete data — the org fetch is what decides whether they have one.
  if (isLoading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '100vh' }}>
        <Spinner animation="border" role="status" />
      </div>
    );
  }

  // Only redirect when we have an AUTHORITATIVE answer that the user has no org
  // (a successful fetch that returned zero). A transient fetch error leaves
  // organizations at [] with orgsFetched=false; redirecting on that wrongly
  // bounced real org owners to /account-setup (#12).
  if (authStatus === 'authenticated' && orgsFetched && !hasOrganizations) {
    return <Navigate to="/account-setup" replace />;
  }

  return children;
};

export default AccountSetupGate;
